import React, { useContext } from "react";
import './App.css'
// import { ConnectKitButton } from "connectkit";
import { useReadContract, useWriteContract } from 'wagmi'
import { abi, deployedaddr } from './contract/info.jsx'
import { formatEther, parseEther } from 'viem'
import { useAccount } from "wagmi";
import { config } from "./components/config.jsx";
import Navbar from "./components/navbar.jsx";
import { useState, useEffect } from "react";
import { useBalance } from 'wagmi'
import { useWaitForTransactionReceipt } from 'wagmi'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Nft from "./components/nft.jsx";
import Swap from "./components/swap.jsx";
import Home from "./components/home.jsx";
import Footer from "./components/footer.jsx";
import SignUp from "./components/signup.jsx";
import { Triangle } from "react-loader-spinner";
import { InfinitySpin } from "react-loader-spinner";
import UserDashboard from "./components/userdashboard.jsx";
import Signin from "./components/signin.jsx";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import AdminDashboard from "./components/adminDashboard.jsx";
import AppContext from "./context/appContext.jsx";
import Education from "./components/education.jsx";
import About from "./components/about.jsx";
import Contact from "./components/contact.jsx";

// import { useWriteContract } from "wagmi"

// import './App.css';

function App() {
  const appContext = useContext(AppContext)
  const { mainLoader } = appContext
  const location = useLocation()

  const [setVisibility, setSetVisibility] = useState(false)


  useEffect(() => {

    if (mainLoader) {
      setSetVisibility(true)
    }
    if (!mainLoader) {
      setTimeout(() => {
        setSetVisibility(false)
      }, 500);
    }

  }, [mainLoader])

  return (

    <div >
      {!(location.pathname.startsWith("/user-dashboard") || location.pathname.startsWith("/admin-dashboard") || location.pathname === "/sign-in" || location.pathname.startsWith("/sign-up")) && <Navbar />}


      <div style={{
        visibility: setVisibility ? "visible" : "hidden",
        zIndex: mainLoader ? 99 : 0,
        opacity: mainLoader ? 1 : 0,
        backdropFilter: "brightness(0.1)",
        transition: "all ease 0.5s"
      }}
        className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center">
        {/* <Triangle
          visible={true}
          height="80"
          width="80"
          color="#fff"
          ariaLabel="triangle-loading"
          wrapperStyle={{}}
          wrapperClass=""
        /> */}
        <InfinitySpin
          visible={true}
          width="200"
          color="#09fafb"
          ariaLabel="infinity-spin-loading"
        />
      </div>
      <Switch>
        <Route exact path="/">
          {/* <Swap /> */}
          <Home />
        </Route>
        <Route exact path="/education">
          {/* <Swap /> */}
          <Education />
        </Route>
        <Route exact path="/about">
          {/* <Swap /> */}
          <About />
        </Route>
        <Route exact path="/contact">
          {/* <Swap /> */}
          <Contact />
        </Route>
        <Route exact path="/user-dashboard*">
          {/* <Swap /> */}
          <UserDashboard />
          {/* <Home /> */}
        </Route>
        <Route exact path="/admin-dashboard*">
          {/* <Swap /> */}
          <AdminDashboard />
          {/* <Home /> */}
        </Route>
        <Route exact path="/sign-in">
          {/* <Swap /> */}
          <Signin />
          {/* <Home /> */}
        </Route>
        <Route exact path="/sign-up/:referralID?">
          {/* <Swap /> */}
          <SignUp />
          {/* <Home /> */}
        </Route>
        {/* <Route exact path="/erc721">
            <Nft />
          </Route> */}


      </Switch>
      {!(location.pathname.startsWith("/user-dashboard") || location.pathname.startsWith("/admin-dashboard") || location.pathname === "/sign-in" || location.pathname.startsWith("/sign-up")) && <Footer />}

      {/* <Footer/> */}

    </div>


  );
}

export default App;
